import { render, staticRenderFns } from "./zbhf.vue?vue&type=template&id=0164698b"
import script from "./zbhf.vue?vue&type=script&lang=js"
export * from "./zbhf.vue?vue&type=script&lang=js"
import style0 from "./zbhf.vue?vue&type=style&index=0&id=0164698b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports